import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { Observable } from 'rxjs';
import { ApiVisa } from '../../shared';
import { CashbookImportContainerModel } from '../../../../../../models/aggregates/erp/index';

@Injectable({
    providedIn: 'root'
})
export class CashbookImportFileService extends BaseApiTemplateService<CashbookImportContainerModel> {
 
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-import-file';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-import-file';
        this.httpClient = http;
    }

    public upload(formData: FormData, cashbookGuid: string, visa: ApiVisa) {
        let url = visa.api_domain_url + this.endpoint_path + '/upload-csv/senheng';
       
        if (this.endpoint_path && visa.api_domain_url) {
            url = url + cashbookGuid;
          }
       
        return this.httpClient.post(url,formData,this.getHttpHeader(visa));
    }

    public generateTxnLines(hdrGuid:string,visa:ApiVisa){
        let url = visa.api_domain_url + this.endpoint_path + '/generate-txn-lines';
       
        if (this.endpoint_path && visa.api_domain_url) {
            url = url + hdrGuid;
          }
        return this.httpClient.post(url, null, this.getHttpHeader(visa));
        
    }
}
